import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {QuotesPage} from '../../../quotes/quotes-page'

export const Route = createFileRoute('/_app/quotes/')({
    component: QuotesRoute,
})

function QuotesRoute() {
    return (
        <Container size="lg" py="xl">
            <QuotesPage />
        </Container>
    )
}
